export const Open = {
  login: {
    url: "/login",
    method: ["POST"],
    required: ["username", "password"]
  },
  open: {
    url: "/open",
    method: ["GET"],
    required: []
  },
  register: {
    url: "/open/register",
    method: ["POST"],
    required: [
      "firstName",
      "lastName",
      "email",
      "password",
      "passwordConfirmation",
      "encryptedInviterId",
      "newsletterOptIn",
      "programId",
      "publisherId",
      "clickId",
      "utm_source",
      "utm_campaign",
      "utm_medium",
      "utm_content",
      "registrationURL",
      "registrationMedium",
      "phone",
      "zipCode",
      "birthday"
    ]
  },
  registerSimple: {
    url: "/open/register/simple",
    method: ["POST"],
    required: [
      "firstName",
      "lastName",
      "email",
      "password",
      "passwordConfirmation",
      "newsletterOptIn"
    ]
  },
  registerNewsletter: {
    url: "/open/register/newsletter",
    method: ["POST"],
    required: ["email"]
  },
  forgotPassword: {
    url: "/open/forgotpassword",
    method: ["POST"],
    required: ["email"]
  },
  productReviews: {
    url: "/open/productreviews/{productId}",
    method: ["GET"]
  },
  locationFromCep: {
    url: "/open/location/cep/{cep}",
    method: ["POST"]
  },
  listStates: {
    url: "/open/location/states",
    method: ["GET"]
  },
  listStateCities: {
    url: "/open/location/cities",
    method: ["GET"],
    required: [
      "stateId"
    ]
  },
  loginWithFacebook: {
    url: "/open/loginwithfacebook",
    method: ["POST"],
    required: ["token_type", "expires_in", "access_token"]
  },
  listEditions: {
    url: "/open/editions",
    method: ["GET"]
  },
  listBrands: {
    url: "/open/brands",
    method: ["GET"]
  },
  getBrandDetails: {
    url: "/open/brands/{brandId}",
    method: ["GET"]
  },
  getProductVariantDetail: {
    url: "/open/product/brand/{productVariantId}",
    method: ["GET"]
  },
  listShoppingProducts: {
    url: "/open/product/shopping",
    method: ["GET"]
  },
  subscriptionList: {
    url: "/open/subscription/list/{id}",
    method: ["GET"]
  },
  nextEdition: {
    url: "/open/edition/next",
    method: ["GET"]
  },
  editionDetail: {
    url: "/open/edition/detail/{editionId}",
    method: ["GET"]
  },
  processExecution: {
    url: "/open/processexecution/{token}",
    method: ["POST"]
  },
  subscriptionTypePrice: {
    url: "/open/subscription/type/price",
    method: ["GET"]
  },
  voucherCheck: {
    url: "/open/voucher/check",
    method: ["POST"],
    required: [
      "voucherNumber",
      "voucherProvider"
    ]
  },
  shippingCost: {
    url: "/open/shippingcost/validate",
    method: ["POST"],
    required: [
      "subscriptionTypeId"
    ]
  },
};
